import { InjectionToken } from '@angular/core';
import { NavigationItemEntity } from '@/app/platform/platform-data/models/navigation-item.entity';

function moveDraggedItemAsFirstChild(
  movedItem: NavigationItemEntity,
  target: NavigationItemEntity
): NavigationItemEntity {
  movedItem.makeFirstChildOf(target);
  return movedItem;
}

function moveDraggedItemBelow(
  movedItem: NavigationItemEntity,
  target: NavigationItemEntity
): NavigationItemEntity {
  const shouldNotBeMoved = target.isFirstSiblingAbove(movedItem);
  if (shouldNotBeMoved) {
    return movedItem;
  }

  movedItem.takePlaceOf(target);
  if (!movedItem.isSiblingOf(target)) {
    movedItem.makeSiblingOf(target);
    movedItem.moveDown(1);
  }
  return movedItem;
}

function moveDraggedItemAbove(
  movedItem: NavigationItemEntity,
  target: NavigationItemEntity
): NavigationItemEntity {
  const isSiblingAbove = movedItem.isSiblingAbove(target);
  movedItem.takePlaceOf(target);
  if (isSiblingAbove) {
    movedItem.moveUp();
  }
  movedItem.makeSiblingOf(target);
  return movedItem;
}

export type NavigationItemMovement = 'below' | 'center' | 'above';

export const NAVIGATION_ITEM_MOVING_STRATEGIES = new InjectionToken<NavigationItemMovingStrategies>(
  ''
);

export type NavigationItemMovingStrategy = (
  movedItem: NavigationItemEntity,
  target: NavigationItemEntity
) => NavigationItemEntity;
export type NavigationItemMovingStrategies = Record<
  NavigationItemMovement,
  NavigationItemMovingStrategy
>;

export const navigationItemMovingStrategies: NavigationItemMovingStrategies = {
  above: moveDraggedItemAbove,
  below: moveDraggedItemBelow,
  center: moveDraggedItemAsFirstChild
};
